import { render, staticRenderFns } from "./AddLinks.vue?vue&type=template&id=73013f45&scoped=true&"
import script from "./AddLinks.vue?vue&type=script&lang=ts&"
export * from "./AddLinks.vue?vue&type=script&lang=ts&"
import style0 from "./AddLinks.vue?vue&type=style&index=0&id=73013f45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73013f45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextField,VTooltip})
